import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {UpdateLayout} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateLayout() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({id, body, camerasIds}: {id: number; body?: UpdateLayout; camerasIds?: Array<number>}) => {
      if (body) await api.layout.update(id, body)
      if (camerasIds?.length) await api.layout.updateCameras(id, {layoutCameras: {adding: camerasIds}})
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.LAYOUTS]})
      enqueueSnackbar('Layout atualizado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível atualizar o layout no momento')
    },
  })
  return mutation
}
